module.exports = "/_next/static/images/fab17ff1c152cbd30ce33a1d5ff59fcf-woman-with-iphone-short-form@1x.jpg.webp";